import script from "./EditVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./EditVideo.vue?vue&type=script&setup=true&lang=js"

import "./EditVideo.vue?vue&type=style&index=0&id=43c4b495&lang=css"

const __exports__ = script;

export default __exports__